import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ValidationState } from '../../types';

const initialState: ValidationState = {
  hasRun: false,
  conflicts: [],
  openEndpoints: [],
  loops: 0,
  railCount: 0,
  closed: false,
};

const validationSlice = createSlice({
  name: 'validation',
  initialState,
  reducers: {
    setValidation: (_state, action: PayloadAction<Omit<ValidationState, 'hasRun'>>) => {
      return { ...action.payload, hasRun: true };
    },
    clearValidation: () => initialState,
  },
});

export const { setValidation, clearValidation } = validationSlice.actions;

export default validationSlice.reducer;
